/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    width: 180,
    label: '项目参与人',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'fullName',
    slot: 'input'
  },
  {
    width: 180,
    label: '经营者',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'operator',
    slot: 'input'
  },
  {
    width: 180,
    label: '个体',
    tip: '请输入关键字',
    key: 'merchant',
    id: 'merchant',
    slot: 'input'
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input'
  },
  {
    width: 180,
    label: '启用状态',
    tip: '请选择订单类型',
    key: 'openStatus',
    id: 'openStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '全部',
        key: ''
      },
      {
        name: '启用',
        key: 1
      },
      {
        name: '未启用',
        key: 2
      }
    ]
  },
  {
    width: 180,
    tip: '请选择订单类型',
    key: 'invoiceOrderType',
    id: 'invoiceOrderType',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '支付订单',
        key: 1
      },
      {
        name: '综合服务费',
        key: 2
      }
    ]
  }
];
